"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      d: "M5.778 11.701c.233 0 .353.126.372.541h-.77c.045-.447.202-.54.397-.54Z"
    }), (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M21.915 4c.552 0 .835.448.835 1v14c0 .552-.283 1-.835 1H2.25a1 1 0 0 1-1-1V7.87c0-.281.118-.549.324-.738l3.129-2.87A1 1 0 0 1 5.378 4h16.537ZM5.778 10.856c-1.102 0-1.794.681-1.795 1.746 0 1.052.592 1.7 1.839 1.7.73 0 1.146-.151 1.474-.327v-.762h-.447c-.177.107-.435.201-.807.201-.39 0-.598-.114-.655-.53h2.035c0-.044.012-.15.012-.308 0-1.159-.548-1.72-1.656-1.72Zm9.054-.963v4.41h1.184v-2.735h.019l.82 2.735h.83l.825-2.735h.02v2.735h1.447v-4.41h-1.895l-.662 2.217h-.018l-.661-2.217h-1.909Zm-4.78-.196c-1.052 0-1.789.467-1.789 1.424 0 .939.49 1.242 1.297 1.418.466.1.705.132.705.39 0 .202-.202.297-.554.297-.371 0-.667-.127-.83-.285h-.593v.952c.333.207.832.353 1.486.353 1.247 0 1.902-.548 1.902-1.462 0-.838-.34-1.215-1.467-1.442-.428-.088-.624-.139-.624-.353 0-.189.158-.277.516-.277.322 0 .618.107.776.226h.591v-.932c-.359-.189-.818-.309-1.416-.309Zm2.453.139v4.41h1.498v-4.41h-1.498Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};